import { Fragment } from 'react';
import { Box, Card, Divider, Grid, Stack, Typography } from '@mui/material';
import { BORDER_MAIN, BORDER_RADIUS_L, CitToken, H1, Section, useBreakpoints } from 'shared';

import { statCards } from '../constants';

export const TokenCitHero = () => {
  const { isDownMdLayout } = useBreakpoints();

  return (
    <Section sx={{ mb: { xs: 5, md: 6 } }}>
      <H1 text="CRAT Impact Token (CIT)" highlightedWords={[0, 1]} sx={{ maxWidth: 905 }} />
      <Typography variant="h4" className="summary regular" sx={{ mt: 3, maxWidth: 900 }}>
        The Gamified Engagement Layer of the CratD2C Ecosystem
      </Typography>

      <Stack alignItems="center" spacing={{ xs: 4, md: 5 }} sx={{ mt: { xs: 4, md: 5 } }}>
        <Box
          component="img"
          src={CitToken}
          alt="CIT token"
          sx={{
            width: { xs: 148, md: 231 },
            height: 'auto',
          }}
        />

        <Card
          sx={{
            width: '100%',
            px: 2.5,
            py: 2,
            borderRadius: BORDER_RADIUS_L,
            border: BORDER_MAIN,
            boxShadow: 'none',
          }}
        >
          <Grid container rowSpacing={{ xs: 1.5, md: 0 }}>
            {statCards.map(({ label, value, accent }, index) => {
              const last = index === statCards.length - 1;
              const even = index % 2 === 0;

              return (
                <Fragment key={label}>
                  <Grid item xs={6} md={3}>
                    <Stack
                      justifyContent="center"
                      sx={{
                        height: '100%',
                        pr: {
                          xs: even ? 2 : 0,
                          md: last ? 0 : 2,
                        },
                        pl: {
                          xs: even ? 0 : 2,
                          md: index === 0 ? 0 : 2,
                        },
                        borderRight: {
                          xs: even ? BORDER_MAIN : 'none',
                          md: last ? 'none' : BORDER_MAIN,
                        },
                      }}
                    >
                      <Typography variant="body1" className="secondary">
                        {label}
                      </Typography>
                      <Typography
                        variant="h4"
                        className={accent ? 'accent' : ''}
                        sx={{
                          mt: 1,
                          wordBreak: 'break-word',
                          fontSize: {
                            xs: 16,
                            md: 20,
                          },
                        }}
                      >
                        {value}
                      </Typography>
                    </Stack>
                  </Grid>
                  {!even && !last && isDownMdLayout && (
                    <Grid item xs={12}>
                      <Divider orientation="horizontal" sx={{ height: 'auto' }} />
                    </Grid>
                  )}
                </Fragment>
              );
            })}
          </Grid>
        </Card>
      </Stack>
    </Section>
  );
};
